import React from 'react';
import { MessageCircle } from 'lucide-react';
import Seo from '../components/Seo';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Credibility from '../components/Credibility';
import ProductTabs from '../components/ProductTabs';
import Segments from '../components/Segments';
import IntegrationsCarousel from '../components/IntegrationsCarousel';
import { Pricing, FAQ, FinalCTA } from '../components/Sections';
import Footer from '../components/Footer';

const WhatsappFAB = () => (
  <a
    href="https://wa.me/5511974512072?text=Ol%C3%A1%21+Quero+saber+mais+sobre+a+CoreDesk"
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-2xl hover:scale-110 transition-transform"
    aria-label="Falar no WhatsApp"
  >
    <MessageCircle size={24} className="text-white" />
    <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
  </a>
);

const Home = () => (
  <>
    <Seo home path="/" />
    <Header />
    <main>
      <Hero />
      <Credibility />
      <ProductTabs />
      <Segments />
      <IntegrationsCarousel />
      <Pricing />
      <FAQ />
      <FinalCTA />
    </main>
    <Footer />
    <WhatsappFAB />
  </>
);

export default Home;
